// extracted by mini-css-extract-plugin
module.exports = {"mCard":"Kk-z","image":"Lk-z","imageNoBackground":"Mk-z"};